import EditIcon from "@mui/icons-material/Edit";
import { Grid } from "@mui/material";
import { useRef } from "react";
import useStyles from "./ImageCard.styles";

interface ImageCardProps {
  src?: string;
  imageContainerStyles?: string;
  onFileSelect?: (file: File) => void;
  accept?: string;
}

const ImageCard = ({
  src,
  imageContainerStyles,
  onFileSelect,
  accept = "image/*",
}: ImageCardProps) => {
  const classes = useStyles();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0 && onFileSelect) {
      onFileSelect(files[0]);
      // Reset input value to allow selecting the same file again
      event.target.value = "";
    }
  };

  return (
    <Grid item xs={6} container className={classes.nameContainer}>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
        accept={accept}
      />
      <Grid
        item
        className={`${classes.imageContainer} ${imageContainerStyles} ${
          !src ? classes.placeholderContainer : classes.imageWithHover
        }`}
        onClick={handleClick}
      >
        {src ? (
          <>
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={src}
            />
            <div className={`${classes.hoverOverlay} hoverOverlay`}>
              <EditIcon />
            </div>
          </>
        ) : (
          <div className={classes.placeholder}>
            <EditIcon />
          </div>
        )}
      </Grid>
    </Grid>
  );
};

export default ImageCard;
